export default __webpack_public_path__ + "static/media/sad.624cf8bc.mp3";